import styled from 'styled-components/macro';

const Content = styled.div`
  padding: 11px 14px 32px;
`;

export default Content;
